import React, { useRef, useMemo } from "react";
import PictureDisplay from "../../../global/PictureDisplay";
import { convertUrl } from "../../helpers/url.helper";

export const ImageGroup = ({ settings, contentLayoutModuleId, environment, isSmartphone, orders }) => {
  const { images = [], overrideAspectRatio, overriddenAspectRatio, showText, showImage } = settings;

  const imageList = useMemo(() => Array.from(images), [images, environment.lang]);
  const imageRefs = useRef({});

  if (isSmartphone) {
    return (
      <>
        {showImage ? (
          <div className="cms-image-group-row">
            {imageList.map(({ src, srcset, text, link, target }, i) => {
              const imageStyle = {
                maxWidth: "100%",
                maxHeight: "100%",
                width: "100%",
                aspectRatio:
                  overrideAspectRatio && overriddenAspectRatio && (/\d+ ?\/ ?\d+/.test(overriddenAspectRatio) || overriddenAspectRatio === "1")
                    ? overriddenAspectRatio
                    : `${imageRefs.current[i]?.naturalWidth} / ${imageRefs.current[i]?.naturalHeight}`,
              };
              return (
                <React.Fragment key={i}>
                  <div className="cms-image-group-container image" style={{ position: "relative", width: `100%` }}>
                    <PictureDisplay
                      src={src}
                      srcset={srcset}
                      link={convertUrl(link, orders !== undefined && orders.length > 0 ? orders[0] : null)}
                      target={target}
                      id={`${contentLayoutModuleId}_image`}
                      ref={(ref) => (imageRefs.current[i] = ref)}
                      style={imageStyle}
                    />
                  </div>
                  {showText && <div key={i} className="cms-image-group-container text" style={{ width: `calc(100% / ${images.length})` }} dangerouslySetInnerHTML={{ __html: text[environment.lang] }}></div>}
                </React.Fragment>
              );
            })}
          </div>
        ) : null}
        {showText && !showImage ? (
          <div className="cms-image-group-row cms-image-text">
            {imageList.map(({ text }, i) => {
              return <div key={i} className="cms-image-group-container text" style={{ width: `100%` }} dangerouslySetInnerHTML={{ __html: text[environment.lang] }}></div>;
            })}
          </div>
        ) : null}
      </>
    );
  }
  if (!showImage && !showText) return null;

  return (
    <>
      {showImage ? (
        <div className="cms-image-group-row">
          {imageList.map(({ src, srcset, link, target }, i) => {
            const imageStyle = {
              maxWidth: "100%",
              maxHeight: "100%",
              height: imageRefs.current[i]?.naturalHeight > imageRefs.current[i]?.naturalWidth ? "100%" : undefined,
              width: imageRefs.current[i]?.naturalHeight > imageRefs.current[i]?.naturalWidth ? undefined : "100%",
              aspectRatio:
                overrideAspectRatio && overriddenAspectRatio && (/\d+ ?\/ ?\d+/.test(overriddenAspectRatio) || overriddenAspectRatio === "1")
                  ? overriddenAspectRatio
                  : `${imageRefs.current[i]?.naturalWidth} / ${imageRefs.current[i]?.naturalHeight}`,
            };
            return (
              <div key={i} className="cms-image-group-container image" style={{ width: `calc(100% / ${images.length})` }}>
                <PictureDisplay
                  src={src}
                  srcset={srcset}
                  link={convertUrl(link, orders !== undefined && orders.length > 0 ? orders[0] : null)}
                  target={target}
                  id={`${contentLayoutModuleId}_image`}
                  ref={(ref) => (imageRefs.current[i] = ref)}
                  style={imageStyle}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {showText ? (
        <div className="cms-image-group-row cms-image-text">
          {imageList.map(({ text }, i) => {
            return <div key={i} className="cms-image-group-container text" style={{ width: `calc(100% / ${images.length})` }} dangerouslySetInnerHTML={{ __html: text[environment.lang] }}></div>;
          })}
        </div>
      ) : null}
    </>
  );
};
